export default function genererCriteresRechercheCompteAnalytique() {
  return {
    auto: null,
    actif: true,
  };
}
